// Nhóm "Nhiệm vụ": danh sách (icon, tên, loại, màn, Xu, bật/tắt, đổi thứ tự) + thêm/sửa qua modal. Không có nút xoá — chỉ tắt.
import { useState } from "react";
import { Button, Switch, Tag } from "antd";
import { faArrowDown, faArrowUp, faListCheck, faPen, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { GroupCard, NumField } from "./xu-config-fields";
import XuMissionEditModal from "./xu-mission-edit-modal";
import { missionIcon } from "./xu-mission-icon-options";
import { screenConflict } from "./xu-mission-validate";

const bySort = (a, b) => (a[1].order - b[1].order) || a[0].localeCompare(b[0]);

export default function XuConfigMissionsCard({ config, set, onReset, missionMeta }) {
    const { missions } = config;
    const [edit, setEdit] = useState(undefined); // undefined = đóng, null = tạo mới, string = key đang sửa
    const rows = Object.entries(missions).sort(bySort);
    const typeLabel = (t) => missionMeta.types.find((x) => x.value === t)?.label || t;
    const screenLabel = (s) => missionMeta.screens.find((x) => x.value === s)?.label || s;
    const put = (next) => set({ missions: next });
    const toggle = (key, on) => put({ ...missions, [key]: { ...missions[key], enabled: on } });
    // Đổi chỗ 2 dòng kề nhau: gán lại order = vị trí mới (0..n) để không trùng số.
    const move = (i, d) => {
        const keys = rows.map(([k]) => k);
        [keys[i], keys[i + d]] = [keys[i + d], keys[i]];
        put(Object.fromEntries(Object.entries(missions).map(([k, m]) => [k, { ...m, order: keys.indexOf(k) + 1 }])));
    };
    const enabledSum = rows.filter(([, m]) => m.enabled).reduce((s, [, m]) => s + (m.reward || 0), 0);
    const full = rows.length >= missionMeta.max;
    return (
        <GroupCard
            id="xu-sec-missions" icon={faListCheck} tone="text-indigo-500" title="Nhiệm vụ hằng ngày" onReset={onReset}
            description="Mỗi ngày người dùng làm các nhiệm vụ đang bật, xong thì bấm “Nhận” để lấy Xu. Nhiệm vụ không xoá được, chỉ Tắt để giữ thống kê."
        >
            <div className="space-y-2">
                {rows.map(([key, m], i) => {
                    const clash = screenConflict(missions, key, m);
                    return (
                        <div key={key} className={`flex items-center gap-3 border rounded-xl p-2 ${m.enabled ? "" : "opacity-60"}`}>
                            <div className="w-9 h-9 rounded-lg bg-indigo-50 text-indigo-600 flex items-center justify-center shrink-0"><FontAwesomeIcon icon={missionIcon(m.icon)} /></div>
                            <div className="flex-1 min-w-0">
                                <div className="font-medium truncate">{m.title} <span className="text-[10px] text-gray-300 font-normal">{key}</span></div>
                                <div className="text-xs text-gray-500">
                                    {typeLabel(m.type)}
                                    {m.type === "view_screen" && ` · màn ${screenLabel(m.screen)} · ${m.seconds} giây`}
                                    {m.type === "buy_now" && ` · ${(m.goldenHours || []).join(", ")}`}
                                    {m.type === "order_app" && ` · đơn trong ${m.maxOrderAgeHours} giờ`}
                                </div>
                                {clash && <div className="text-xs text-red-500">Trùng màn với nhiệm vụ “{clash}” — chỉ được bật 1.</div>}
                            </div>
                            <Tag color="gold">+{m.reward} Xu</Tag>
                            <Switch checked={m.enabled} checkedChildren="Bật" unCheckedChildren="Tắt" onChange={(v) => toggle(key, v)} />
                            <Button size="small" icon={<FontAwesomeIcon icon={faPen} />} onClick={() => setEdit(key)}>Sửa</Button>
                            <Button size="small" type="text" disabled={i === 0} icon={<FontAwesomeIcon icon={faArrowUp} />} onClick={() => move(i, -1)} />
                            <Button size="small" type="text" disabled={i === rows.length - 1} icon={<FontAwesomeIcon icon={faArrowDown} />} onClick={() => move(i, 1)} />
                        </div>
                    );
                })}
            </div>
            <Button className="mt-3" icon={<FontAwesomeIcon icon={faPlus} />} disabled={full} onClick={() => setEdit(null)}>Thêm nhiệm vụ xem màn hình</Button>
            {full && <span className="text-xs text-gray-400 ml-2">Đã đủ {missionMeta.max} nhiệm vụ.</span>}
            <div className="mt-4">
                <NumField label="Thưởng thêm khi làm xong TẤT CẢ nhiệm vụ đang bật" unit="Xu" value={config.allMissionsBonus} onChange={(v) => set({ allMissionsBonus: v })} className="mb-0"
                    hint={`Tổng thưởng tối đa mỗi ngày từ nhiệm vụ: ${enabledSum + (config.allMissionsBonus || 0)} Xu (trần Xu mỗi người mỗi ngày: ${config.dailyCap}). Thêm nhiệm vụ giữa ngày thì ai chưa nhận thưởng thêm sẽ phải làm thêm nhiệm vụ đó.`} />
            </div>
            {edit !== undefined && (
                <XuMissionEditModal
                    key={edit || "new"} editKey={edit} missions={missions} meta={missionMeta}
                    onCancel={() => setEdit(undefined)}
                    onOk={(key, entry) => { put({ ...missions, [key]: entry }); setEdit(undefined); }}
                />
            )}
        </GroupCard>
    );
}
